<div fxLayout="column" *ngIf="loaderService?.isLoading | async">
  <mat-toolbar class="mat_toolbar">
    <span style="font-size: initial;">Authenticating</span>
  </mat-toolbar>
  <mat-progress-bar class="query-progress" mode="query" *ngIf="loaderService?.isLoading | async"></mat-progress-bar>
</div>